import { lockerActionTypes } from './lockerActionTypes';
import { sessionActionTypes } from './sessionActionTypes';
import { kioskDataActionTypes } from './kioskDataActionTypes';
import { devicesActionTypes } from './devicesActionTypes';

export const ActionType = {
  ...lockerActionTypes,
  ...kioskDataActionTypes,
  ...sessionActionTypes,
  ...devicesActionTypes,
};
